// The fee list for extra fee lines on the LACW billing sheet: VLA table, ATLAS fee name and
// amount, as supplied by Emma on 14 Oct 2026. The same names and amounts drive the Aid
// Planner's claim tracker (src/lib/aidPlannerCriminalFees.js); this is the flat list the
// billing sheet picks from, so a diary entry can carry more than one fee.
//
// Amounts are per unit: per appearance, per day, or per kilometre for the travel fees.

export const BILLING_FEE_TABLE = {
  "Table A – Single summary (Magistrates'/Children's)": [
    ["CONSOL CONT MENTION", 581],
    ["PREPARATION", 484],
    ["APPEARANCE", 484],
    ["DEFEND/CONTEST DAILY FEE", 1099],
    ["CONTEST MENTION", 332],
    ["PLEA AT CONTEST MENTION", 318],
    ["CRED/DRUG COURT MENTION", 185],
    ["JAIL CONFERENCE", 185],
    ["ADJOURNMENT", 318],
    ["BRIEF SENTENCE INDICATION", 484],
    ["APPEAR AT SENTENCE", 318],
    ["TRAVEL FEE", 0.83],
    ["OVERNIGHT FEE", 394],
    ["TAPE TRANSCRIPTION", 99],
    ["FOI/TITLE LODG/SEARCH FEE", 668],
    ["SERVICE/FILING/COND MONEY", 617],
    ["SPECIAL MENTION - SUMMARY", 185],
    ["FIRST REMAND HEARING", 231],
    ["SUMMARY CRIME MENTION", 185],
    ["URGENT PREPARATION", 277],
    ["CONSOLIDATED PREPARATION", 579],
    ["CONSOLIDATED URGENT PREPARATION", 348],
    ["CONSOLIDATED APPEARANCE", 579],
    ["CONSOLIDATED ADJOURNMENT", 369],
    ["CONSOLIDATED PLEA AT CONTEST MENTION", 369],
    ["MENTION HEARING", 185],
    ["ARC RATIFICATION HEARING", 332],
    ["ARC REVIEW HEARING", 185],
    ["GROUP CONFERENCE", 464],
    ["GROUP CONFERENCE (AFTER HOURS)", 594],
    ["YCO PLANNING MEETING", 358],
    ["YCO MONITORING HEARING", 185],
    ["YCO MONITORING (OPPOSE VARIATION)", 318],
    ["YCO BREACH", 484],
    ["APPLICATION FOR SUMMARY JURISDICTION", 890],
  ],
  "Table B – Bail (Magistrates'/Children's)": [
    ["BAIL PREPARATION", 362],
    ["BAIL APPEARANCE", 557],
    ["BAIL TRAVEL FEE", 0.83],
    ["BAIL OVERNIGHT FEE", 394],
    ["BAIL FOI/TITLE LODG/SEARCH FEE", 668],
    ["BAIL SERVICE/FILING/COND MONEY", 617],
    ["BAIL FIRST REMAND HEARING", 231],
  ],
  "Table B addition – Children's Court bail (Intensive Bail)": [
    ["INTENSIVE BAIL SCHEME SUPERVISION", 185],
  ],
  "Table C – County Court bail": [
    ["CC BAIL PREPARATION", 1030],
    ["CC BAIL APPEARANCE", 968],
    ["CC BAIL MENTION", 298],
    ["CC BAIL TRAVEL FEE", 0.83],
    ["CC BAIL OVERNIGHT", 394],
  ],
  "Table D – Supreme Court bail": [
    ["SC BAIL PREPARATION", 1043],
    ["SC BAIL APPEARANCE", 1041],
    ["SC BAIL TRAVEL FEE", 0.83],
    ["SC BAIL OVERNIGHT", 394],
  ],
  "Table E – Indictable committal": [
    ["COMMITTAL PREPARATION", 712],
    ["COMMITTAL BRIEF ANALYSIS", 712],
    ["COMMITTAL ADDITIONAL PREPARATION", 890],
    ["COMMITTAL MENTION", 445],
    ["COMMITTAL GROUND RULES HEARING", 484],
    ["COMMITTAL SPECIAL MENTION", 178],
    ["COMMITTAL CONTEST DAY 1", 1284],
    ["COMMITTAL CONTEST DAY 2+", 1157],
    ["COMMITTAL JAIL CONFERENCE", 185],
    ["COMMITTAL PLEA", 537],
    ["COMMITTAL SENTENCE", 318],
  ],
  "Table F(i) – Children's Court indictable": [
    ["SERIOUS INDICTABLE PREPARATION", 719],
    ["SERIOUS INDICTABLE CONTEST MENTION", 356],
    ["SERIOUS INDICTABLE APPEARANCE", 1214],
    ["SERIOUS INDICTABLE SUMMARY JURISDICTION", 890],
    ["SERIOUS INDICTABLE GROUP CONFERENCE", 534],
    ["SERIOUS INDICTABLE GROUP CONFERENCE AFTER HOURS", 712],
    ["SERIOUS INDICTABLE YCO PLANNING", 358],
    ["SERIOUS INDICTABLE YCO MONITORING", 185],
    ["SERIOUS INDICTABLE YCO OPPOSE VARIATION", 318],
    ["SERIOUS INDICTABLE YCO BREACH", 484],
    ["SERIOUS INDICTABLE SENTENCE", 358],
    ["SERIOUS INDICTABLE TAPE TRANSCRIPTION", 99],
  ],
  "Table F – County Court indictable": [
    ["CC POST-COMMITTAL NEGOTIATIONS", 714],
    ["CC FIRST DIRECTIONS HEARING", 476],
    ["CC DIRECTIONS HEARING", 297],
    ["CC DEFENCE RESPONSE DIRECTIONS", 476],
    ["CC APPLICATION DISCONTINUANCE", 595],
    ["CC PLEA PREPARATION", 561],
    ["CC PLEA APPEARANCE DAY 1", 1834],
    ["CC PLEA APPEARANCE SUBSEQUENT", 638],
    ["CC SENTENCE", 356],
    ["CC ADVICE ON APPEAL", 326],
    ["CC SPECIAL HEARING PREPARATION", 187],
    ["CC SPECIAL HEARING DAY 1", 2501],
    ["CC SPECIAL HEARING SUBSEQUENT", 1370],
    ["CC SENTENCE INDICATION", 1350],
    ["CC GROUND RULES HEARING", 1370],
    ["CC S198A APPLICATION", 714],
    ["CC S198A EXAMINATION", 1370],
    ["CC S198A PREPARATION", 935],
    ["CC S198A INITIAL DIRECTIONS HEARING", 595],
    // Youth fees in the higher courts, from 19 Oct 2026 (VLA Table F).
    ["CC GROUP CONFERENCE (CHILD) - WORK HOURS", 714],
    ["CC GROUP CONFERENCE (CHILD) - OUTSIDE WORK HOURS", 952],
    ["CC YSSO/YCO PLANNING MEETING", 374],
    ["CC YSSO/YCO REPORTING AND MONITORING HEARING", 297],
    ["CC YSSO/YCO MONITORING (OPPOSE VARIATION)", 535],
    ["CC YSSO/YCO BREACH OR REVOCATION", 714],
    ["CC ACMS CASE INITIATION", 476],
    ["CC ACMS INSTRUCTOR PREPARATION", 714],
    ["CC ACMS COUNSEL PREPARATION", 1612],
    ["CC ACMS APPEARANCE", 1370],
    ["CC ACMS INSTRUCTING", 165],
    ["CC ACMS TRQ CERTIFICATE", 476],
    ["CC ACMS CASE ASSESSMENT", 596],
    ["CC TRIAL PREPARATION", 1870],
    ["CC TRIAL DEFENCE RESPONSE", 476],
    ["CC TRIAL APPEARANCE DAY 1", 2982],
    ["CC TRIAL APPEARANCE DAY 1 UPLIFT", 3578],
    ["CC TRIAL SUBSEQUENT", 1370],
    ["CC TRIAL INSTRUCTING", 165],
    ["CC PLEA HEARING DAY 1", 1106],
    ["CC PLEA HEARING SUBSEQUENT", 638],
    ["CC TRIAL SENTENCE", 356],
    ["CC TRIAL ADVICE ON APPEAL", 978],
  ],
  "Table F – Supreme Court indictable": [
    ["SC POST-COMMITTAL NEGOTIATIONS", 978],
    ["SC FIRST DIRECTIONS HEARING", 652],
    ["SC DIRECTIONS HEARING", 407],
    ["SC DEFENCE RESPONSE DIRECTIONS", 652],
    ["SC APPLICATION DISCONTINUANCE", 815],
    ["SC PLEA PREPARATION", 2533],
    ["SC PLEA APPEARANCE DAY 1", 2504],
    ["SC PLEA APPEARANCE SUBSEQUENT", 1002],
    ["SC SENTENCE", 491],
    ["SC ADVICE ON APPEAL", 326],
    ["SC SPECIAL HEARING PREPARATION", 298],
    ["SC SPECIAL HEARING DAY 1", 3410],
    ["SC SPECIAL HEARING SUBSEQUENT", 2197],
    ["SC SENTENCE INDICATION", 1838],
    ["SC GROUND RULES HEARING", 2197],
    ["SC S198B APPLICATION", 894],
    ["SC S198B APPEARANCE", 2197],
    // Youth fees in the higher courts, from 19 Oct 2026 (VLA Table F).
    ["SC GROUP CONFERENCE (CHILD) - WORK HOURS", 714],
    ["SC GROUP CONFERENCE (CHILD) - OUTSIDE WORK HOURS", 952],
    ["SC YSSO/YCO PLANNING MEETING", 374],
    ["SC YSSO/YCO REPORTING AND MONITORING HEARING", 297],
    ["SC YSSO/YCO MONITORING (OPPOSE VARIATION)", 535],
    ["SC YSSO/YCO BREACH OR REVOCATION", 714],
    ["SC COUNSEL CALLOVER PREPARATION", 652],
    ["SC CASE CONFERENCE", 1838],
    ["SC TRIAL PREPARATION", 4470],
    ["SC TRIAL DEFENCE RESPONSE", 652],
    ["SC TRIAL APPEARANCE DAY 1", 4737],
    ["SC TRIAL APPEARANCE DAY 1 UPLIFT", 5684],
    ["SC TRIAL SUBSEQUENT", 2197],
    ["SC TRIAL INSTRUCTING", 298],
    ["SC PLEA HEARING DAY 1", 1508],
    ["SC PLEA HEARING SUBSEQUENT", 1002],
    ["SC TRIAL SENTENCE", 491],
    ["SC TRIAL ADVICE ON APPEAL", 978],
  ],
  "Table G – County Court sentence appeal": [
    ["CC SENTENCE APPEAL PREPARATION", 1030],
    ["CC SENTENCE APPEAL APPEARANCE", 968],
    ["CC SENTENCE APPEAL SENTENCE HEARING", 356],
    ["CC SENTENCE APPEAL MENTION", 298],
    ["CC SENTENCE APPEAL TRAVEL", 0.83],
    ["CC SENTENCE APPEAL OVERNIGHT", 394],
  ],
  "Table H – County Court conviction appeal": [
    ["CC CONVICTION APPEAL PREPARATION", 1028],
    ["CC CONVICTION APPEAL MENTION", 297],
    ["CC CONVICTION APPEAL APPEARANCE", 1087],
    ["CC CONVICTION APPEAL SENTENCE", 356],
    ["CC CONVICTION APPEAL TRAVEL", 0.83],
    ["CC CONVICTION APPEAL OVERNIGHT", 394],
  ],
  "Table J – County Court breach": [
    ["PREPARATION", 1028],
    ["DAILY HEARING FEE", 1087],
    ["MENTION", 297],
    ["APPEAR AT SENTENCE", 356],
  ],
  "Table J – Supreme Court breach": [
    ["SC BREACH PREPARATION", 2086],
    ["SC BREACH MENTION", 407],
    ["SC BREACH APPEARANCE", 2273],
    ["SC BREACH SENTENCE", 491],
  ],
  "Table K – Court of Appeal": [
    ["COA LEAVE PREPARATION", 596],
    ["COA GROUNDS OF APPEAL (CONVICTION)", 1630],
    ["COA GROUNDS OF APPEAL (SENTENCE)", 978],
    ["COA REVISION OF GROUNDS", 326],
    ["COA RENEWAL APPLICATION", 326],
    ["COA ORAL HEARING", 326],
    ["COA RENEWAL PREPARATION", 298],
    ["COA RENEWAL GROUNDS", 652],
    ["COA RENEWAL BRIEF", 631],
    ["COA RENEWAL SUBSEQUENT", 326],
    ["COA RENEWAL JUDGMENT", 491],
    ["COA SENTENCE SOLICITOR PREPARATION", 894],
    ["COA SENTENCE BRIEF", 2269],
    ["COA SENTENCE SUBSEQUENT", 1511],
    ["COA SENTENCE JUDGMENT", 491],
    ["COA CONVICTION SOLICITOR PREPARATION", 1490],
    ["COA CONVICTION BRIEF", 2269],
    ["COA CONVICTION SUBSEQUENT", 1511],
    ["COA CONVICTION JUDGMENT", 491],
  ],
  "Table K(i) – Court of Appeal (DPP appeal)": [
    ["COA DPP SOLICITOR PREPARATION", 1937],
    ["COA DPP SC APPEARANCE", 5203],
    ["COA DPP SC SUBSEQUENT", 4310],
    ["COA DPP SC SUBMISSIONS", 4360],
    ["COA DPP JC BRIEF", 2228],
    ["COA DPP JC SUBSEQUENT", 1854],
    ["COA DPP JC SUBMISSIONS", 3260],
    ["COA DPP JUDGMENT", 491],
  ],
  "Table K(ii) – Interlocutory appeal": [
    ["INTERLOCUTORY SOLICITOR PREPARATION", 596],
    ["INTERLOCUTORY COUNSEL PREPARATION", 652],
    ["INTERLOCUTORY LEAVE APPLICATION", 1511],
    ["INTERLOCUTORY APPEAL APPEARANCE", 2269],
    ["INTERLOCUTORY SUBSEQUENT", 1511],
  ],
  "Table L – High Court": [
    ["HC SPECIAL LEAVE PREPARATION", 3129],
    ["HC SPECIAL LEAVE APPEARANCE", 2269],
    ["HC SPECIAL LEAVE SUBSEQUENT", 1511],
    ["HC SPECIAL LEAVE JUDGMENT", 491],
    ["HC SPECIAL LEAVE GROUNDS AND SUBMISSIONS", 3260],
    ["HC APPEAL PREPARATION", 3725],
    ["HC APPEAL APPEARANCE", 2269],
    ["HC APPEAL SUBSEQUENT", 1511],
    ["HC APPEAL JUDGMENT", 491],
    ["HC APPEAL GROUNDS AND SUBMISSIONS", 3260],
    ["HC APPEAL INSTRUCTING HALF DAY", 752],
  ],
  "Table T – Mental impairment (County Court)": [
    ["CMIA CC ROUTINE APPEARANCE", 707],
    ["CMIA CC PREPARATION", 1496],
    ["CMIA CC APPEARANCE DAY 1", 2982],
    ["CMIA CC SUBSEQUENT", 1370],
    ["CMIA CC MENTION", 297],
    ["CMIA CC JUDGMENT", 356],
    ["CMIA CC INSTRUCTING", 165],
  ],
  "Table T – Mental impairment (Supreme Court)": [
    ["CMIA SC ROUTINE APPEARANCE", 1344],
    ["CMIA SC PREPARATION", 2384],
    ["CMIA SC APPEARANCE DAY 1", 4737],
    ["CMIA SC SUBSEQUENT", 2197],
    ["CMIA SC MENTION", 407],
    ["CMIA SC JUDGMENT", 491],
    ["CMIA SC INSTRUCTING", 298],
  ],
  "Table Y – Chief Examiner / witness assistance": [
    ["CHIEF EXAMINER ADVICE", 467],
    ["CHIEF EXAMINER BRIEF DAILY", 1350],
  ],
  "Table Z – Serious offenders (County Court)": [
    ["SOA CC SUPERVISION PREPARATION", 935],
    ["SOA CC SUPERVISION BRIEF", 2501],
    ["SOA CC SUPERVISION SUBSEQUENT", 1370],
    ["SOA CC SUPERVISION MENTION", 298],
    ["SOA CC SUPERVISION INSTRUCTING", 165],
    ["SOA CC SUPERVISION JUDGMENT", 356],
    ["SOA CC REVIEW PREPARATION", 935],
    ["SOA CC REVIEW APPEARANCE", 1087],
    ["SOA CC REVIEW MENTION", 298],
    ["SOA CC REVIEW JUDGMENT", 356],
  ],
  "Table Z – Serious offenders (Supreme Court)": [
    ["SOA SC EDO PREPARATION", 1043],
    ["SOA SC EDO APPEARANCE", 1050],
    ["SOA SC EDO MENTION", 408],
    ["SOA SC EDO JUDGMENT", 491],
    ["SOA SC DETENTION PREPARATION", 2980],
    ["SOA SC DETENTION BRIEF", 4737],
    ["SOA SC DETENTION SUBSEQUENT", 2197],
    ["SOA SC DETENTION MENTION", 408],
    ["SOA SC DETENTION INSTRUCTING", 298],
    ["SOA SC DETENTION JUDGMENT", 491],
    ["SOA SC SUPERVISION PREPARATION", 2086],
    ["SOA SC SUPERVISION BRIEF", 4074],
    ["SOA SC SUPERVISION SUBSEQUENT", 2197],
    ["SOA SC SUPERVISION MENTION", 408],
    ["SOA SC SUPERVISION INSTRUCTING", 298],
    ["SOA SC SUPERVISION JUDGMENT", 491],
    ["SOA SC REVIEW PREPARATION", 2086],
    ["SOA SC REVIEW APPEARANCE", 2273],
    ["SOA SC REVIEW MENTION", 408],
    ["SOA SC REVIEW JUDGMENT", 491],
  ],
  "Table A4 – Family violence (FVPA)": [
    ["FV PREPARATION", 431],
    ["FV URGENT PREPARATION", 247],
    ["FV COURT ORDERED CROSS EXAMINATION PREPARATION", 247],
    ["FV DIRECTIONS HEARING", 161],
    ["FV APPEARANCE", 431],
    ["FV CONTEST APPEARANCE", 605],
    ["FV ADJOURNMENT", 431],
    ["FV TRAVEL", 0.83],
    ["FV OVERNIGHT", 394],
  ],
  "Table A5 – Personal safety intervention orders": [
    ["PSIO PREPARATION", 431],
    ["PSIO URGENT PREPARATION", 247],
    ["PSIO DIRECTIONS HEARING", 161],
    ["PSIO APPEARANCE", 431],
    ["PSIO CONTEST APPEARANCE", 605],
    ["PSIO ADJOURNMENT", 431],
    ["PSIO TRAVEL", 0.83],
    ["PSIO OVERNIGHT", 394],
  ],
  "Psychological assessment (DISB51)": [
    ["PSYCHOL-NON ATTENDANCE", 82],
    ["PSYCHOL REP+JAIL VISIT", 850],
  ],
  "CRSM8 – Consolidated extension uplift": [
    ["CONSOL PREPARATION", 95],
    ["CONSOL APPEARANCE", 95],
    ["CONSOL PLEA AT CONTEST MENTION", 51],
    ["CONSOL ADJOURNMENT", 51],
    ["CONSOL BRIEF SENTENCE INDICATION", 95],
    ["CONSOL APPEAR AT SENTENCE", 51],
  ],
};

// A fee's key is its table and name together, because the same name appears in more than
// one table at different amounts (PREPARATION is $484 in Table A and $1,028 in Table J).
export const feeKey = (table, name) => `${table} | ${name}`;

/** Every fee as { key, table, name, amount }, in table order. */
export const BILLING_FEE_LIST = Object.entries(BILLING_FEE_TABLE).flatMap(([table, rows]) =>
  rows.map(([name, amount]) => ({ key: feeKey(table, name), table, name, amount })));

const BY_KEY = new Map(BILLING_FEE_LIST.map((fee) => [fee.key, fee]));

/** The fee for a key, or null. */
export const findBillingFee = (key) => BY_KEY.get(key) || null;

/** Fees charged per kilometre rather than per appearance. */
export const isPerKilometre = (fee) => Boolean(fee) && /TRAVEL/.test(fee.name) && fee.amount < 5;
